import React, { useState, useEffect } from 'react';
import styles from './TargetingSystem.module.css';

function TargetingSystem({ isTargeting, targetingStartTime }) {
  const [targetingPhase, setTargetingPhase] = useState('idle'); // 'idle', 'locked', 'launched'

  // Handle targeting phases
  useEffect(() => {
    if (isTargeting && targetingStartTime) {
      // Phase 1: Target Lock (orange) - immediate
      setTargetingPhase('locked');
      
      // Phase 2: Ordinance Launched (after 4 seconds)
      const launchTimeout = setTimeout(() => {
        setTargetingPhase('launched');
      }, 4000);
      
      // Phase 3: Return to idle (after 6 seconds when modal opens)
      const resetTimeout = setTimeout(() => {
        setTargetingPhase('idle');
      }, 6000);

      return () => {
        clearTimeout(launchTimeout);
        clearTimeout(resetTimeout);
      };
    } else {
      setTargetingPhase('idle');
    }
  }, [isTargeting, targetingStartTime]);

  const getDisplayContent = () => {
    switch (targetingPhase) {
      case 'locked':
        return {
          header: 'TARGET LOCK',
          status: 'TARGET ACQUIRED',
          theme: 'orange'
        };
      case 'launched':
        return {
          header: 'ORDINANCE LAUNCHED',
          status: 'PROBE DEPLOYED',
          theme: 'red'
        };
      default:
        return {
          header: 'TARGET SCAN',
          status: 'NO TARGET',
          theme: 'green'
        };
    }
  };

  const displayContent = getDisplayContent();

  return (
    <div className={styles.targetingSystem}>
      <div className={`${styles.targetingHeader} ${styles[displayContent.theme]}`}>
        {displayContent.header}
      </div>
      
      <div className={`${styles.targetingDisplay} ${styles[displayContent.theme]}`}>
        <div className={styles.statusText}>
          {displayContent.status}
        </div>
      </div>
    </div>
  );
}

export default TargetingSystem;
